import Post from "../Post";
import getToken from "../token";

export default function addFaq(text, shortcut, textEn = null) {
  return Post("doctor/addFaqDoctor", {
    token: getToken(),
    textFa: text,
    textEn: "",
    shortCut: shortcut,
  });
}
